import { IBillingV1 } from '../tools/api.service';
import { Injectable } from "@angular/core";

@Injectable()
export class Billing {
    // billingSocialReason: string;
    // billingAddress: string;
    // billingPostalCode: string;
    // billingCity: string;
    // billingCountry: string;
    // billingSiret: string;
    // billingTva:string;

    // public static parseToIBilling(item: Billing): IBillingV1 {
    //     let result = new IBillingV1();
    //     result.billingSocialReason = item.billingSocialReason;
    //     result.billingAddress = item.billingAddress;
    //     result.billingPostalCode = item.billingPostalCode;
    //     result.billingCity = item.billingCity;
    //     result.billingCountry = item.billingCountry;
    //     result.billingSiret = item.billingSiret;
    //     result.billingTva = item.billingTva;

    //     return result;
    // }
}